// extracted by mini-css-extract-plugin
export default {"Authorization":"Authorization_Authorization__kZU3e","AuthorizationInput":"Authorization_AuthorizationInput__vd3l8","AuthorizationButton":"Authorization_AuthorizationButton__QH71i"};